"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _AppContext = _interopRequireDefault(require("../../context/AppContext"));

var _UserCard = _interopRequireWildcard(require("../UserCard"));

var _SuggestionsList = _interopRequireDefault(require("./SuggestionsList.scss"));

var _UserAvatar = _interopRequireDefault(require("../UserAvatar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var SuggestionsList = /*#__PURE__*/_react.default.memo(function (_ref) {
  var suggestions = _ref.suggestions,
      selectedIndex = _ref.selectedIndex,
      onUserCardClick = _ref.onUserCardClick,
      onUserCardHover = _ref.onUserCardHover;

  var _useContext = (0, _react.useContext)(_AppContext.default),
      compactLayout = _useContext.compactLayout;

  var suggestionsListClasses = (0, _classnames.default)(_SuggestionsList.default.component, compactLayout ? 'above' : 'below');
  var onSuggestionClick = (0, _react.useCallback)(function (_evt, suggestionIndex) {
    onUserCardClick(suggestionIndex);
  }, [onUserCardClick]);
  var onSuggestionHover = (0, _react.useCallback)(function (_evt, suggestionIndex) {
    onUserCardHover(suggestionIndex);
  }, [onUserCardHover]);
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: suggestionsListClasses,
    id: "ccx-suggestion-list",
    role: "listbox"
  }, suggestions.map(function (suggestionUser, suggestionIndex) {
    var selected = selectedIndex === suggestionIndex;
    return (
      /*#__PURE__*/
      // Using the user's image string as the key here since PGC provides a unique, ID-based URL for the src
      _react.default.createElement("li", {
        key: suggestionUser.token,
        "aria-selected": selected,
        "data-testid": "ccx-comments-suggestion-container",
        id: "suggestion-".concat(suggestionIndex),
        role: "option",
        tabIndex: "-1"
      }, /*#__PURE__*/_react.default.createElement(_UserCard.default, {
        id: suggestionIndex,
        onClick: onSuggestionClick,
        onHover: onSuggestionHover,
        selected: selected,
        user: suggestionUser
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "avatar-column"
      }, /*#__PURE__*/_react.default.createElement(_UserAvatar.default, {
        user: suggestionUser
      })), /*#__PURE__*/_react.default.createElement(_UserCard.UserCardBody, null, /*#__PURE__*/_react.default.createElement(_UserCard.UserCardName, {
        title: suggestionUser.name
      }, suggestionUser.name), /*#__PURE__*/_react.default.createElement(_UserCard.UserCardEmail, {
        title: suggestionUser.email
      }, suggestionUser.email), /*#__PURE__*/_react.default.createElement(_UserCard.UserCardOrgName, {
        title: suggestionUser.orgName
      }, suggestionUser.orgName))))
    );
  }));
});

SuggestionsList.displayName = 'SuggestionsList';
SuggestionsList.propTypes = {
  onUserCardClick: _propTypes.default.func,
  onUserCardHover: _propTypes.default.func,
  selectedIndex: _propTypes.default.number,
  suggestions: _propTypes.default.array
};
SuggestionsList.defaultProps = {
  onUserCardClick: function onUserCardClick() {},
  onUserCardHover: function onUserCardHover() {},
  selectedIndex: 0,
  suggestions: []
};
var _default = SuggestionsList;
exports.default = _default;